export enum FilterType {
  SingleSelect,
  Search
}
